import { render, staticRenderFns } from "./Protein3dView.vue?vue&type=template&id=ad799864&scoped=true&"
import script from "./Protein3dView.vue?vue&type=script&lang=js&"
export * from "./Protein3dView.vue?vue&type=script&lang=js&"
import style0 from "./Protein3dView.vue?vue&type=style&index=0&id=ad799864&prod&lang=css&"
import style1 from "./Protein3dView.vue?vue&type=style&index=1&id=ad799864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad799864",
  null
  
)

export default component.exports